<app-spinner-overlay></app-spinner-overlay>
<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo
      titolo="Configurazione Informativa Aziendale"
      subTitolo="Rivedi, crea e configura le informative aziendali"
    ></app-titolo-subtitolo>
  </div>

  <mat-tab-group>
    <!-- INFORMATIVE -->
    <mat-tab label="Informative Aziendali">
      <app-lista-tabellare
        #tabella
        [fnCaricamentoDati]="fnCaricamentoDati"
        [colonne]="colonne"
        [filtri]="filtri"
        (bottoniListaClick)="bottoniListaClick($event)"
      >
        <div btnEnd>
          <button mat-flat-button class="primary-button" color="primary" (click)="creaNuovo()">
            Nuovo
          </button>
        </div>
      </app-lista-tabellare>
    </mat-tab>

    <!-- DOMANDE -->
    <mat-tab label="Configurazione Domande">
      <app-lista-tabellare
        #tabellaDomande
        [fnCaricamentoDati]="fnCaricamentoDatiDomande"
        [colonne]="colonneDomande"
        [filtri]="filtriDomande"
        (bottoniListaClick)="bottoniListaClickDomande($event)"
      >
        <div btnEnd>
          <button
            mat-flat-button
            class="primary-button"
            color="primary"
            (click)="creaNuovaDomanda()"
          >
            Nuovo
          </button>
        </div>
      </app-lista-tabellare>
    </mat-tab>
  </mat-tab-group>
</div>
